import PrestadoresHabilitadosListContainer from './PrestadoresHabilitadosListContainer';

export default PrestadoresHabilitadosListContainer;
